import { mainnet, bsc } from '@reown/appkit/networks'
import { createAppKit } from '@reown/appkit'
import { WagmiAdapter } from '@reown/appkit-adapter-wagmi'

// Wagmi persists a stripped connector object in `wagmi.store`. Older builds
// can restore that object before AppKit has reconnected the real connector,
// which makes AppKit call a missing `getProvider()` method on page reload.
const WALLET_SDK_CACHE_VERSION = 'appkit-wagmi-1.8.23-connector-migration-2'

const clearLegacyWalletSdkCache = () => {
  if (typeof window === 'undefined' || !window.localStorage) return

  try {
    const storage = window.localStorage
    if (storage.getItem('walletSdkCacheVersion') === WALLET_SDK_CACHE_VERSION) return

    const keys = []
    for (let index = 0; index < storage.length; index += 1) {
      const key = storage.key(index)
      if (key && (key.startsWith('@appkit/') || key.startsWith('wagmi.'))) keys.push(key)
    }
    keys.forEach((key) => storage.removeItem(key))
    storage.setItem('walletSdkCacheVersion', WALLET_SDK_CACHE_VERSION)
  } catch (error) {
    // Wallet initialization must remain available when browser storage is unavailable.
  }
}

clearLegacyWalletSdkCache()

const projectId = process.env.VUE_APP_REOWN_PROJECT_ID || 'f18258c4a42a9715471cef482b5156a5'
if (!projectId) {
  throw new Error('VITE_PROJECT_ID is not set')
}

export const networks = [mainnet, bsc]

const storedChainId = typeof window === 'undefined' ? 1 : Number(window.localStorage.getItem('cur_chainId') || 1)
const initialNetwork = networks.find((network) => network.id === storedChainId) || mainnet
//Set up the Wagmi Adapter (Config)
export const wagmiAdapter = new WagmiAdapter({
  projectId,
  networks,
})

const appKitOptions = {
  adapters: [wagmiAdapter],
  networks,
  projectId,
  basic: true,
  enableNetworkSwitch: true,
  themeMode: 'dark',
  themeVariables: {
    '--w3m-accent': '#000000',
    '--w3m-font-family': 'system-ui, sans-serif',
    '--apkt-font-family': 'system-ui, sans-serif',
  },
  featuredWalletIds: [
	"4622a2b2d6af1c9844944291e5e7351a6aa24cd7b23099efac1b2fd875da31a0",
    "f2436c67184f158d1beda5df53298ee84abfc367581e4505134b5bcf5f46697d",
	"c57ca95b47569778a828d19178114f4db188b89b763c899ba0be274e97267d96"
  ],
  features: {
    analytics: false,
  }
}

if (initialNetwork) {
  appKitOptions.defaultNetwork = initialNetwork
}

export const appKit = createAppKit(appKitOptions)
